export default __webpack_public_path__ + "static/datelabel-dropdown-dont-2-dark-d2fe3a7bc1258dadc4b6ae26f87dacdb.png";